/* eslint-disable react-hooks/exhaustive-deps */
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import './styles/App.module.scss';
import Register from './pages/register';
import ForgotPassword from './pages/forgot-password';
import ResetPassword from './pages/resetPassword';
import FullScreenLoader from './components/loader';
import { useEffect, useState } from 'react';
import { getProfile, logout } from 'services/api/users';
import {
  isAdmin,
  isConnected,
  isLocalhost,
  // isLocalhost,
} from 'utils/utils';
import Login from 'pages/login';
import Verify from 'pages/verify';
import Auth from 'pages/auth';
import ProfileContext from 'services/profileContext';
import Settings from 'pages/settings';
import posthog from 'posthog-js';
import ImpersonateWarningBanner from 'components/impersonateWarningBanner';
import CreateCycle from 'pages/create-cycle';
import Cycle from 'pages/cycles/[id]';
import Cycles from 'pages/cycles';
import Users from 'pages/users';
import MyCycles from 'pages/my/cycles';
import MyCycle from 'pages/my/cycles/[myCycleId]';
import Onboarding from 'pages/onboarding';
import UpgradeBanner from 'components/upgradeBanner';
import BannerWrapper from 'components/bannerWrapper';
import PaymentSuccess from 'pages/payment-success';
import ProtectedLayout from 'components/protectedLayout';
import { needUpgrade } from 'utils/utils';
import RefHandler from 'components/refHandler';

function App() {
  const [loading, setLoading] = useState(false);
  const [firstLoadDone, setFirstLoadDone] = useState(false);
  const resetProfile = () =>
    setProfile({
      profile: {},
      updateProfile: getUserProfile,
      clearProfile: resetProfile,
    });

  const getUserProfile = () => {
    if (loading) return;
    setLoading(true);
    return getProfile()
      .then(({ data }) => {
        if (!isLocalhost() && !data.impersonated) {
          if (!profile?.profile) {
            posthog.init('phc_5fBIoRXvW8LIHpBfcB2O9AoFYif1a8xQv80PFfLjG8d', {
              api_host: 'https://t.buddieshr.com',
              defaults: '2026-05-30',
            });
          }
          posthog.identify(data._id, {
            name: `${data.profile?.firstName} ${data.profile?.lastName}`,
            email: data.email,
            workspaceId: data.workspace?._id,
            workspaceName: data.workspace?.name,
            slackTeamId: data.workspace?.slack?.teamId,
            slackTeamName: data.workspace?.slack?.name,
          });
        }
        setProfile({
          profile: data,
          updateProfile: getUserProfile,
          clearProfile: resetProfile,
        });
        return data;
      })
      .catch((err) => {
        if (
          err &&
          err.response &&
          (err.response.status === 401 ||
            err.response.status === 500 ||
            err.response.status === 404)
        ) {
          logout(() => {
            window.location.replace(`${window.location.origin}/#/login`);
            resetProfile();
          });
        } else {
          console.error(err);
        }
      })
      .finally(() => {
        setLoading(false);
        setFirstLoadDone(true);
      });
  };

  const [profile, setProfile] = useState({
    profile: null,
    updateProfile: getUserProfile,
    clearProfile: resetProfile,
  });


  useEffect(() => {
    if (isConnected()) {
      getUserProfile();
    } else {
      setFirstLoadDone(true);
    }
  }, []);

  return (
    <div className="App">
      <ProfileContext.Provider value={profile}>
        <HashRouter>
          {!isConnected() && <RefHandler />}
          <BannerWrapper>
            {profile && profile.profile && profile.profile.impersonated && (
              <ImpersonateWarningBanner profile={profile.profile} />
            )}
            {profile &&
              isAdmin(profile.profile) &&
              !profile.profile?.workspace?.buddiesSubscription &&
              profile.profile?.workspace?.freeTrialStartDate &&
              !needUpgrade(profile) && (
                <UpgradeBanner />
              )}
          </BannerWrapper>
          {firstLoadDone && (
            <Routes>
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/forgot-password"
                exact
                element={<ForgotPassword />}
              />
              <Route
                path="/reset-password/:resetPasswordToken"
                element={<ResetPassword />}
              />
              <Route path="/verify/:email" element={<Verify />} />
              <Route
                path="/auth/:sessionId"
                element={<Auth getProfileInfo={getUserProfile} />}
              />
              {isConnected() ? (
                profile?.profile && profile?.profile?._id ? (
                  <Route element={<ProtectedLayout />}>
                    {isAdmin(profile.profile) && (
                      <>
                        <Route path="/cycles" element={<Cycles />} />
                        <Route path="/create-cycle" element={<CreateCycle />} />
                        <Route path="/cycles/:id" element={<Cycle />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="/onboarding" element={<Onboarding />} />
                      </>
                    )}
                    <Route path="/my/cycles" element={<MyCycles />} />
                    <Route path="/my/cycles/:myCycleId" element={<MyCycle />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route
                      path="/payment-success"
                      element={<PaymentSuccess />}
                    />
                  </Route>
                ) : (
                  <></>
                )
              ) : (
                <Route path="/" element={<Navigate to="/login" replace />} />
              )}

              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          )}
        </HashRouter>
      </ProfileContext.Provider>
      {loading && <FullScreenLoader />}
    </div>
  );
}

export default App;
